import {map as _map} from 'lodash';

export const thirdPartyTunnelsColumns = {
    'id': {
        label: 'ID',
        sorting: true,
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'name': {label: 'Name', sorting: true},
    'vtd_tunnel': {
        label: 'VTD tunnel',
        sorting: false,
    },
    'vtd_tunnel_status': {
        label: 'VTD tunnel status',
        sorting: true,
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'encoding_job_profile': {
        label: 'Encoding job profile',
        sorting: (row) => (row.encoding_job_profile.name.capitalizeFirstLetter()),
    },
    'output_client_reference': {
        label: 'Output client reference',
        sorting: (row) => _map(row.output_references, (element) => element.output_reference),
    },
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
};
